import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db, functions } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import { connect } from 'react-redux';

// Actions
import { set_ShowBottomSpinner, clearUser, getUserById, clearPeople, capitalizeFirstLetter } from '../../actions/authActions';
import { toggleMessageModal } from '../../actions/navActions';
import { getNewGroups_Helper } from '../../actions/groupActions';

// Components - imported
import Spinner from '../common/Spinner';
import GroupBlock from './GroupBlock';

const PAGE_SIZE = 5;

// Displays if the user is logged in AND has set up profile
const AllNewGroupsSection = ({ 
    
}) => {
    // Users List
    const [groupsData, setGroupsData] = useState([]);
    const [gotGroups, setGotGroups] = useState(false);
    const [groupsList, setGroupsList] = useState([]);

    useEffect(() => {

        fetchGroups();

    }, []);

    useEffect(() => {

        renderGroupList();

    }, [groupsData, gotGroups]);

    const fetchGroups = async () => {
        console.log('Fetching new groups')
        try {
            console.log('ABOUT TO FETCH GROUPS...');
            // Fetch groups
            const tempGroupList = await getNewGroups_Helper({ page_size: PAGE_SIZE });

            console.log('UPDATING GROUPS...');
    
            setGroupsData(tempGroupList);
            setGotGroups(true);
        } catch (error) {
            console.log("Error: failed to fetch new groups");
            console.log(error);
        }
    }

    const renderGroupList = async () => {
        setGroupsList([]);

        if(!gotGroups) {
            setGroupsList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(groupsData.length > 0) {
                groupsData.map(group_doc => {
                    setGroupsList(groupsList => [...groupsList, (
                        <GroupBlock group_doc={group_doc} />
                    )])
                }) 
            } else {
                setGroupsList(userList => [...userList, (
                    <div className="no-rides">
                        <h1>No groups found</h1>
                    </div>
                )])
                
            }
        } 
    }

    // Don't Render component if there's not data
    if(gotGroups && groupsData.length === 0) return <></>;

    // Render the component
    return (
        <div style={{padding: '16px 0', borderBottom: '1px solid #e6ecf0', width: '100%'}}>
            {/* Section Title */}
            <div style={{padding: '0 16px', color:'rgb(15, 20, 25)', marginBottom: '8px', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                <span style={{fontSize: '1.125rem'}}>New groups</span>
            </div>

            {groupsList?.slice(0, PAGE_SIZE) || []}

            {/* See more btn */}
            {(groupsData.length > 0 && !(groupsData.length < PAGE_SIZE)) && (

                <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                    <div onClick={() => window.location = '/discover/new-groups'} className='see_more_btn full_width'>
                        See all
                    </div>
                </div>
            )}
        </div>
    )
}

// Prop types for the component
AllNewGroupsSection.propTypes = {

    // Prop type validation for function to toggle the Authentication modal
    nav: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    clearUser: PropTypes.func.isRequired,
    getUserById: PropTypes.func.isRequired,
    clearPeople: PropTypes.func.isRequired,
    toggleMessageModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav,
    auth: state.auth,
    group: state.group
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
    set_ShowBottomSpinner,
    clearUser,
    getUserById,
    clearPeople,
    toggleMessageModal
})(AllNewGroupsSection);
